/**
 *
 * @module entry
 * @desc {SDK.UserActivity} entry point.
 *
 */

import UserActivityApi from './userActivityApi';
import UserActivityEvent from './userActivityEvent';
import EventSchema from './eventSchema';
import EventSchemata from './eventSchemata';
import EventSchemataProvider from './eventSchemataProvider';
import EventValue from './eventValue';
import Glimpse from './glimpse/entry';
import Personalization from './personalization/entry';

/**
 *
 * @typedef SDK.UserActivity
 * @type {Object}
 *
 * @property {UserActivityApi} UserActivityApi
 * @property {UserActivityEvent} UserActivityEvent
 * @property {EventSchema} EventSchema
 * @property {EventSchemata} EventSchemata
 * @property {EventSchemataProvider} EventSchemataProvider
 * @property {EventValue} EventValue
 * @property {Glimpse} Glimpse
 * @property {Personalization} Personalization
 *
 */

/**
 *
 * @type {SDK.UserActivity}
 *
 */
export default {

    UserActivityApi,
    UserActivityEvent,
    EventSchema,
    EventSchemata,
    EventSchemataProvider,
    EventValue,
    Glimpse,
    Personalization

};



// WEBPACK FOOTER //
// ./src/userActivity/entry.js